import { useTranslation } from 'react-i18next'
import { useTheme } from '../../context/ThemeProvider'
import { useThemeAssets } from '../../hooks/useThemeAssets'
import { ThemeMode } from '../../constants/theme'
import { getThemeMode } from '../../utils/theme-utils'

const EmptyTicket = () => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const { svgAssets } = useThemeAssets()

  const isDarkMode = getThemeMode(theme) === ThemeMode.DARK
  const noDataImage = isDarkMode
    ? svgAssets.NO_DATA.dark
    : svgAssets.NO_DATA.light

  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      <div className="mb-6">
        <img
          src={noDataImage}
          alt={t('message.empty')}
          className="w-32 h-32 md:w-48 md:h-48 opacity-80"
        />
      </div>

      <div className="text-center">
        <h4 className="text-lg font-medium text-[var(--no-data-text)] mb-2">
          {t('message.empty')}
        </h4>
      </div>
    </div>
  )
}

export default EmptyTicket
